import { render, staticRenderFns } from "./avg-chart.vue?vue&type=template&id=3d4bd4f0&"
import script from "./avg-chart.vue?vue&type=script&lang=js&"
export * from "./avg-chart.vue?vue&type=script&lang=js&"
import style0 from "./avg-chart.vue?vue&type=style&index=0&id=3d4bd4f0&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports